"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyLedgerAppOpen = exports.getLedgerAppName = exports.emitter = void 0;
const hdwallet_ledger_1 = require("@shapeshiftoss/hdwallet-ledger");
const types_1 = require("@shapeshiftoss/types");
const events_1 = __importDefault(require("events"));
exports.emitter = new events_1.default();
const getLedgerAppName = (chainId) => {
    switch (chainId) {
        case types_1.KnownChainIds.ArbitrumMainnet:
        case types_1.KnownChainIds.AvalancheMainnet:
        case types_1.KnownChainIds.ArbitrumNovaMainnet:
        case types_1.KnownChainIds.BaseMainnet:
        case types_1.KnownChainIds.BnbSmartChainMainnet:
        case types_1.KnownChainIds.EthereumMainnet:
        case types_1.KnownChainIds.GnosisMainnet:
        case types_1.KnownChainIds.OptimismMainnet:
        case types_1.KnownChainIds.PolygonMainnet:
            return 'Ethereum';
        case types_1.KnownChainIds.BitcoinCashMainnet:
            return 'Bitcoin Cash';
        case types_1.KnownChainIds.BitcoinMainnet:
            return 'Bitcoin';
        case types_1.KnownChainIds.CosmosMainnet:
            return 'Cosmos';
        case types_1.KnownChainIds.DogecoinMainnet:
            return 'Dogecoin';
        case types_1.KnownChainIds.LitecoinMainnet:
            return 'Litecoin';
        case types_1.KnownChainIds.ThorchainMainnet:
            return 'THORChain';
        default:
            throw Error(`Unsupported chainId: ${chainId}`);
    }
};
exports.getLedgerAppName = getLedgerAppName;
const getCoin = (chainId) => {
    switch (chainId) {
        case types_1.KnownChainIds.BitcoinMainnet:
            return 'Bitcoin';
        case types_1.KnownChainIds.DogecoinMainnet:
            return 'Dogecoin';
        case types_1.KnownChainIds.BitcoinCashMainnet:
            return 'BitcoinCash';
        case types_1.KnownChainIds.LitecoinMainnet:
            return 'Litecoin';
        case types_1.KnownChainIds.EthereumMainnet:
            return 'Ethereum';
        case types_1.KnownChainIds.AvalancheMainnet:
            return 'Avalanche';
        case types_1.KnownChainIds.OptimismMainnet:
            return 'Optimism';
        case types_1.KnownChainIds.BnbSmartChainMainnet:
            return 'BnbSmartChain';
        case types_1.KnownChainIds.PolygonMainnet:
            return 'Polygon';
        case types_1.KnownChainIds.GnosisMainnet:
            return 'Gnosis';
        case types_1.KnownChainIds.ArbitrumMainnet:
            return 'Arbitrum';
        case types_1.KnownChainIds.ArbitrumNovaMainnet:
            return 'ArbitrumNova';
        case types_1.KnownChainIds.BaseMainnet:
            return 'Base';
        case types_1.KnownChainIds.ThorchainMainnet:
            return 'Rune';
        case types_1.KnownChainIds.CosmosMainnet:
            return 'Atom';
        default:
            throw Error(`Unsupported chainId: ${chainId}`);
    }
};
const verifyLedgerAppOpen = async (chainId, wallet) => {
    const coin = getCoin(chainId);
    const appName = (0, exports.getLedgerAppName)(chainId);
    if (!(0, hdwallet_ledger_1.isLedger)(wallet))
        return;
    const isAppOpen = async () => {
        try {
            await wallet.validateCurrentApp(coin);
            return true;
        }
        catch {
            return false;
        }
    };
    if (await isAppOpen())
        return;
    let intervalId;
    try {
        await new Promise((resolve, reject) => {
            // emit event to trigger modal open
            const args = { chainId, reject };
            exports.emitter.emit('LedgerOpenApp', args);
            // prompt user to open app on device
            wallet.openApp(appName);
            intervalId = setInterval(async () => {
                if (!(await isAppOpen()))
                    return;
                // emit event to trigger modal close
                exports.emitter.emit('LedgerAppOpened');
                clearInterval(intervalId);
                resolve();
            }, 1000);
        });
    }
    catch {
        clearInterval(intervalId);
        throw new Error('Ledger app open cancelled');
    }
};
exports.verifyLedgerAppOpen = verifyLedgerAppOpen;
